module.exports = __webpack_public_path__ + "img/314.03ebc679.jpg";